module.exports = __webpack_public_path__ + "static/media/HomeGraphic9.0fce5138.jpg";